import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-body1 text-grey-8 text-weight-light q-mt-md" }, " Avställningar ", -1)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = {
  key: 0,
  class: "row"
}
const _hoisted_6 = { class: "col q-mb-sm" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Det gick inte logga in! ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLogo = _resolveComponent("AppLogo")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_slide_transition = _resolveComponent("q-slide-transition")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "flex items-center justify-center full-width" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { style: {"width":"400px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_q_form, {
            ref: "formRef",
            onSubmit: _withModifiers(_ctx.signIn, ["prevent"]),
            autocomplete: "off",
            greedy: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_AppLogo),
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_q_separator),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_q_input, {
                        disable: _ctx.pending,
                        modelValue: _ctx.model.username,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.username) = $event)),
                        label: "E-mail",
                        type: "email",
                        rules: [_ctx.requiredRule]
                      }, null, 8, ["disable", "modelValue", "rules"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_q_input, {
                        disable: _ctx.pending,
                        modelValue: _ctx.model.password,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.password) = $event)),
                        label: "Lösenord",
                        type: "password",
                        rules: [_ctx.requiredRule]
                      }, null, 8, ["disable", "modelValue", "rules"])
                    ])
                  ]),
                  _createVNode(_component_q_slide_transition, null, {
                    default: _withCtx(() => [
                      (_ctx.error.isError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_component_q_banner, {
                                dense: "",
                                class: "text-white bg-red",
                                rounded: ""
                              }, {
                                avatar: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    size: "xs",
                                    name: "mdi-alert-circle-outline",
                                    color: "white"
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _hoisted_7
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_separator),
              _createVNode(_component_q_card_actions, { align: "right" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_btn, {
                    loading: _ctx.pending,
                    type: "submit",
                    label: "Logga in",
                    color: "primary"
                  }, null, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}